// extracted by mini-css-extract-plugin
export default {"senceForm":"Sence_senceForm__jvynI","hidden":"Sence_hidden__LkmyT"};